import React, { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./Home.css";
import homevideo from "../assets/homevideo.mp4";

function Home() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    navigate("/logoutattendance");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTrackLocation = () => {
  // Open the track location link in a new tab
  window.open("https://track.primeedge.co.in/", "_blank");
};


  const handleValidateData = () => {
    alert("Validate my data clicked!");
    // Add validation logic here
  };
// .....
  return (
    <div className="home-container">
      {/* 🔹 Background Video */}
      <video autoPlay loop muted playsInline className="background-video">
        <source src={homevideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay (to make text readable) */}
      <div className="overlay"></div>
      
      {/* Header */}
      <div className="home-header">
        <div className="header-content">
          
          {/* Menu button on left */}
          {/* <div className="menu-section">
            <button className="menu-btn" onClick={toggleMenu}>
              ☰
            </button>
            {isMenuOpen && (
              <div className="menu-dropdown">
                <button onClick={handleTrackLocation} className="menu-item">
                  📍 Track My Location
                </button>
                <button onClick={handleValidateData} className="menu-item">
                  ✅ Validate My Data
                </button>
              </div>
            )}
          </div> */}

          {/* Logo */}
          <div className="logo-section">
            <div className="logo">
              <span className="logo-icon"></span>
              <h1 className="title">Prime Edge Info Solutions Pvt Ltd</h1>
            </div>
            <p className="tagline">Maintenance Management System</p>
          </div>

          {/* User Info */}
          {user && (
            <div className="user-info">
              <div className="user-details">
                <span className="username">Welcome, {user.username}</span>
                <span className="user-role">Engineer</span>
              </div>
              {user.photo ? (
                <img src={user.photo} alt="profile" className="profile-pic" />
              ) : (
                <div className="profile-placeholder">
                  {user.username[0].toUpperCase()}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="welcome-section">
          <h2>Select a Form to Get Started</h2>
          <p>Choose the appropriate form for your maintenance task</p>
        </div>

        {/* Cards Section */}
        <div className="cards-container">
          {/* <Link to="/amnex" className="card amnex-card">
            <div className="card-icon">🚌</div>
            <div className="card-content">
              <h3>Amnex</h3>
              <p>Access Amnex maintenance form</p>
            </div>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/LowFloor" className="card tnstc-card">
            <div className="card-icon">🚍</div>
            <div className="card-content">
              <h3>AL LowFloor</h3>
              <p>Access AL LowFloor maintenance form</p>
            </div>
            <div className="card-arrow">→</div>
          </Link>

        

          <Link to="/switch" className="card switch-card">
            <div className="card-icon">🚎</div>
            <div className="card-content">
              <h3>Switch</h3>
              <p>Access Switch maintenance form</p>
            </div>
            <div className="card-arrow">→</div>
          </Link>

           <Link to="/OGL" className="card ogl-card">
            <div className="card-icon">🚍</div>
            <div className="card-content">
              <h3>OGL</h3>
              <p>Access OGL maintenance form</p>
            </div>
            <div className="card-arrow">→</div>
          </Link> */}
           <Link to="/Data" className="card ogl-card">
            <div className="card-icon">🚍</div>
            <div className="card-content">
              <h3>Data Entry Form</h3>
              <p>Access Data Entry maintenance form</p>
            </div>
            <div className="card-arrow">→</div>
          </Link>
        </div>
      </div>

      

      {/* Footer */}
      <div className="home-footer">
        {/* <button onClick={handleLogout} className="logout-btn">
          <span className="logout-icon">⎋</span>
          Logout
        </button> */}
        <div className="footer-info">
          <p>Prime Edge Maintenance System</p>
        </div>
      </div>
    </div>
  );
}

export default Home;
